import { isEmpty } from "lodash";

export const permissionsParser = function (moduleName, permissionsList = []) {
  const permissions = {
    view: false,
    view_own: false,
    create: false,
    edit: false,
    edit_own: false,
    delete: false,
    delete_own: false,
    reply: false,
  };
  if (isEmpty(permissionsList)) {
    return permissions;
  }
  const index = permissionsList?.findIndex(
    (permissionModule) => moduleName === permissionModule?.securityPointId?.name
  );

  if (index === -1) {
    return permissions;
  }
  permissionsList[index].bits.forEach((bit) => {
    permissions[bit.key] = bit.value === "true" ? true : false;
  });
  return permissions;
};

export const isEditOwnAccess = (permissions, userId, contentCreationId) => {
  return permissions?.edit_own && userId === contentCreationId;
};

export const isDeleteOwnAccess = (permissions, userId, contentCreationId) => {
  return permissions?.delete_own && userId === contentCreationId;
};
